import React, { useId } from "react";
import { statusLabels } from "../constants";

export function reviewFieldId(field, itemId) {
  return `premium-review-${field}${itemId ? `-${itemId}` : ""}`;
}

export function Field({
  label,
  id: inputId,
  multiline = false,
  children,
  ...props
}) {
  const generatedId = useId();
  const id = inputId || generatedId;
  return (
    <div className="premium-field">
      <label htmlFor={id}>{label}</label>
      {children ? (
        <select id={id} className="form-select" {...props}>
          {children}
        </select>
      ) : multiline ? (
        <textarea id={id} rows={3} className="form-control" {...props} />
      ) : (
        <input id={id} className="form-control" {...props} />
      )}
    </div>
  );
}

export function Check({ label, ...props }) {
  const id = useId();
  return (
    <div className="form-check premium-check">
      <input id={id} type="checkbox" className="form-check-input" {...props} />
      <label htmlFor={id} className="form-check-label">
        {label}
      </label>
    </div>
  );
}

export function Status({ status }) {
  return (
    <span className={`premium-status premium-status-${status}`}>
      {statusLabels[status] || status}
    </span>
  );
}

export function sourceLabel(source, documents) {
  const name = documents.find((doc) => doc.id === source.documentId)?.name;
  return name ? `${name}${source.page ? ` · str. ${source.page}` : ""}` : "";
}
